import React from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import PageNavButton from '../../components/PageNavButton'
import AlertCard from '../../components/AlertCard'
import FooterText from '../../components/PageFooter/FooterText'
import { PagePad } from '../../components/PageWrapper/styles'
const CancelConfirmPage = () => {
  const navigate = useNavigate()
  const AlertCardData = {
    title: 'Cancelation confirmed',
    cardContent: ['CompareBanks cannot access your data from Bank 1.'],
  }
  const bodyText = (
    <p>
      If you decide to share your data with us you will need to start this
      process again.<br></br>
      Learn more about data sharing at{' '}
      <a
        href="javascript:;"
        target="_blank"
        rel="noreferrer"
        title="CDR policy information"
        aria-label="link to CDR policy information"
      >
        comparebanks.com.au/cdr.
      </a>
    </p>
  )

  return (
    <PageWrapper>
      <Helmet>
        <title>Cancelation confirmed</title>
      </Helmet>
      <PageContentWrapper>
        <PagePad padHeight="65px" />
        <AlertCard {...AlertCardData} />
        <FooterText content={bodyText} isDepenednt={true} />
      </PageContentWrapper>
      <PageNavButton
        onClickFunc={() => navigate('/')}
        content="Close"
        //isFocused={true}
        ariaLabel="Close button, to close the process and redirect to the start page double click here"
      />
    </PageWrapper>
  )
}

export default CancelConfirmPage
